interface CountryLike {
  street: string;
  houseNumber: string;
  zipCode: string;
  city: string;
}
export const formatStreetAddress = (location: CountryLike): string => {
  return `${location.street} ${location.houseNumber},
  ${location.zipCode} ${location.city}`;
};
